/**
 * 权限工具类混合
 */
import { mapGetters } from 'vuex'

const AuthUtilMixin = {
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['currUserActionAuth']),
  },
  methods: {
    /**
     * 判断当前用户是否有权限
     * @param sign 权限标识
     */
    hasBtnActionAuth(sign) {
      return this.currUserActionAuth.some((item) => item.action === sign)
    },
  },
}

export { AuthUtilMixin }
